export default __webpack_public_path__ + "static/bg-header2-1b25ead904e2606fd0c30b7038a73472.jpg";